import { render, staticRenderFns } from "./ModuleDemoVideo.vue?vue&type=template&id=0be26980"
import script from "./ModuleDemoVideo.vue?vue&type=script&lang=js"
export * from "./ModuleDemoVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports